import React, { useState } from "react";
import { CONNECTION_STATUS } from "../../utils/constants";
import { ButtonVisibility } from "../../utils/constants";
import { ConnectionButtonVisibilityState } from "../../utils/Interfaces";
import MobConnectionIconActive from "../../assets/theme/images/connection-start-icon.png";
import MobConnectionIconInActive from "../../assets/theme/images/connection-start-icon.png";

import OpenToAnythingIconActive from "../../assets/theme/images/connection-icons/open-to-anything-active.png";
import OpenToAnythingIconInActive from "../../assets/theme/images/connection-icons/open-to-anything-inactive.png";

import DatingIconActive from "../../assets/theme/images/connection-icons/dating-active.png";
import DatingIconInactive from "../../assets/theme/images/connection-icons/dating-inactive.png";

import FriendshipIconActive from "../../assets/theme/images/connection-icons/professional-friendship-active.png";
import FriendshipInActiveIcon from "../../assets/theme/images/connection-icons/professional-friendship-inactive.png";

import SubScreenHeading from "../CustomComponents/ScreenHeader";
import ModalClose from "../../assets/theme/images/modal-drawer-close-icon.png";

import CustomRadio from "../custom-radio";
import Icons from "../../assets/theme/icons";
interface ConnectionButtonProps {
  connectionVisibility: ConnectionButtonVisibilityState;
  isGuestSame: boolean;
  connectionExpanded: boolean;
  requestedConnectionStatus: string;
  toggleConnectionExpanded: () => void;
  sendConnectionRequest: (status: string) => void;
  confirmationOption?: any;
  handleRequestType?: any;
  connectionReqLoader?: boolean;
  showMatchedButton?: boolean;
  openChatModal?: any;
  eventDetailObj?: any;
}

const ConnectionButton = ({
  connectionVisibility,
  isGuestSame,
  connectionExpanded,
  requestedConnectionStatus,
  toggleConnectionExpanded,
  sendConnectionRequest,
  confirmationOption,
  handleRequestType,
  connectionReqLoader,
  showMatchedButton,
  openChatModal,
  eventDetailObj,
}: ConnectionButtonProps) => {
  const [pulseTarget, setPulseTarget] = useState<string | null>(null);

  const handleTouchFeedback = (status: string) => {
    if (requestedConnectionStatus !== status) {
      setPulseTarget(status);
      setTimeout(() => setPulseTarget(null), 400); // reset pulse after animation
    }
  };

  const [touchedCard, setTouchedCard] = useState<string | null>(null);

  const triggerHover = (status: string) => {
    setTouchedCard(status);
    setTimeout(() => setTouchedCard(null), 400); // reset after hover simulation
  };
  const ConnectionOption = (icon: any, label: any, onClick: any) => {
    return (
      <div className="grid place-items-center text-center w-1/3">
        <img
          src={icon}
          alt={label}
          className="cursor-pointer w-16 h-16 md:w-[65%] md:h-auto object-contain"
          onClick={onClick}
        />
        <div className="p-2 text-[#786469] text-sm break-words">{label}</div>
      </div>
    );
  };
  return (
    <>
      {!isGuestSame &&
        (connectionVisibility.openToAnyButtonVisibility ===
          ButtonVisibility.Visible ||
          connectionVisibility.friendshipButtonVisibility ===
            ButtonVisibility.Visible ||
          connectionVisibility.datingButtonVisibility ===
            ButtonVisibility.Visible) && (
          <div
            className="fixed left-0 flex bottom-[2rem] md:bottom-2 justify-center w-full connection-request-button-wrapper"
            id="connection-request-button-wrapper"
          >
            <button
              onClick={toggleConnectionExpanded}
              className="flex items-center justify-center p-2 w-[190px] bg-[#F2DDE2] border-2 border-white text-black font-bold text-[18px] font-[PINYADA-Beranda-Regular] rounded-full shadow-lg hover:bg-[#C08193]"
            >
              <div className="w-16 flex items-center justify-center">
                <img
                  src={
                    connectionExpanded
                      ? MobConnectionIconActive
                      : MobConnectionIconInActive
                  }
                  alt="Connection"
                  className="w-14 h-12 object-contain rounded-full z-30 cursor-pointer"
                />
              </div>

              <div className="flex items-center justify-center w-auto mr-2">
                CONNECT
              </div>
            </button>
          </div>
        )}
      {showMatchedButton && !isGuestSame && (
        <div className="fixed left-0 bottom-[2rem] md:bottom-2  flex justify-center z-50 w-full">
          <button
            onClick={openChatModal}
            className="flex items-center justify-center p-2 w-[190px] bg-[#F2DDE2] border-2 border-white text-black font-bold text-[18px] font-[PINYADA-Beranda-Regular] rounded-full shadow-lg hover:bg-[#C08193]"
          >
            <div className="w-16 flex items-center justify-center">
              <img
                src={Icons.ChatIcon}
                alt="Connection"
                className="w-14 h-12 object-contain rounded-full z-30 cursor-pointer"
              />
            </div>

            <div className="flex items-center justify-center w-auto mr-2">
              MESSAGE
            </div>
          </button>
        </div>
      )}
      {connectionExpanded && (
        <div
          className={`
      fixed inset-x-0 bottom-0 z-50 
      bg-[#F2DDE2] 
      rounded-t-2xl 
      border-t-2 border-white 
      shadow-lg 
      transition-transform duration-300 ease-out
      px-4 
      connection-reuwrapper
  ${
    eventDetailObj && eventDetailObj?.anonymousConnection
      ? "h-2/3 h-[53vh] md:h-[54vh] overflow-y-auto py-6"
      : "h-2/3 h-[35vh] md:h-[38vh] py-4"
  }`}
        >
          <div className="flex w-full justify-between items-center">
            <div className="w-4/6 flex justify-between items-center">
              <SubScreenHeading
                text="Select A Connection Type"
                customClass="text-black"
              />
            </div>
            <div className="w-2/6 flex justify-end item-center">
              <img
                src={ModalClose}
                alt=""
                onClick={toggleConnectionExpanded}
                className="cursor-pointer w-12 h-12"
              />
            </div>
          </div>
          {eventDetailObj && eventDetailObj?.anonymousConnection ? (
            <div className="w-full pt-3">
              <div className="w-full flex items-center gap-2">
                <div className="w-auto text-black">
                  Would you like to send an anonymous connection request?
                </div>
                <div className="w-auto">
                  <CustomRadio
                    value={confirmationOption}
                    onChange={handleRequestType}
                  />
                </div>
              </div>
              <div className="flex gap-2 text-xs text-sm"></div>
              <div className="flex mt-1 items-center justify-between px-0 py-0 bg-transparent text-[#786469] w-full lg:w-4/6 md:w-4/6">
                <span className="text-xs">
                  {confirmationOption
                    ? "Your profile stays hidden until there is mutual interest between you and the recipient."
                    : "Your profile becomes visible to the recipient as soon as you send a connection request."}
                </span>
              </div>
            </div>
          ) : null}
          {connectionReqLoader ? (
            <div className="flex justify-center items-center h-[12rem] p-4">
              Loading...
            </div>
          ) : (
            <div className="flex justify-center items-center h-[12rem] gap-4 py-2">
              {/* Dating */}
              {connectionVisibility.datingButtonVisibility ===
                ButtonVisibility.Visible && (
                <div
                  className="flex flex-col items-center justify-center w-1/3 text-center cursor-pointer group"
                  onClick={() =>
                    sendConnectionRequest(
                      requestedConnectionStatus === CONNECTION_STATUS.DATING
                        ? CONNECTION_STATUS.UNMATCH
                        : CONNECTION_STATUS.DATING
                    )
                  }
                  onTouchStart={() => triggerHover(CONNECTION_STATUS.DATING)}
                  onMouseEnter={() => triggerHover(CONNECTION_STATUS.DATING)}
                >
                  <img
                    src={
                      requestedConnectionStatus === CONNECTION_STATUS.DATING
                        ? DatingIconActive
                        : DatingIconInactive
                    }
                    alt="Dating"
                    style={{
                      filter:
                        requestedConnectionStatus ===
                          CONNECTION_STATUS.DATING ||
                        touchedCard === CONNECTION_STATUS.DATING
                          ? "drop-shadow(0 12px 30px rgba(255,20,147,0.85))"
                          : undefined,
                    }}
                    className={`w-20 h-20 object-contain transition-all duration-300 ease-in-out
          ${
            requestedConnectionStatus === CONNECTION_STATUS.DATING ||
            touchedCard === CONNECTION_STATUS.DATING
              ? "scale-110 rotate-3 animate-pulse"
              : ""
          } group-hover:scale-105 group-hover:-translate-y-1 group-hover:rotate-3`}
                  />
                  <div
                    className={`mt-2 text-xs md:text-sm  group-hover:text-[13.2px] md:group-hover:text-text-[15px]   text-[#786469] transition-all duration-300 ease-in-out ${
                      requestedConnectionStatus === CONNECTION_STATUS.DATING ||
                      touchedCard === CONNECTION_STATUS.DATING
                        ? "font-bold text-pink-600"
                        : ""
                    } group-hover:font-bold group-hover:text-pink-500`}
                  >
                    Dating
                  </div>
                </div>
              )}

              {/* Friendship */}
              {connectionVisibility.friendshipButtonVisibility ===
                ButtonVisibility.Visible && (
                <div
                  className="flex flex-col items-center justify-center w-1/3 text-center cursor-pointer group"
                  onClick={() =>
                    sendConnectionRequest(
                      requestedConnectionStatus === CONNECTION_STATUS.FRIENDSHIP
                        ? CONNECTION_STATUS.UNMATCH
                        : CONNECTION_STATUS.FRIENDSHIP
                    )
                  }
                  onTouchStart={() =>
                    triggerHover(CONNECTION_STATUS.FRIENDSHIP)
                  }
                  onMouseEnter={() =>
                    triggerHover(CONNECTION_STATUS.FRIENDSHIP)
                  }
                >
                  <img
                    src={
                      requestedConnectionStatus === CONNECTION_STATUS.FRIENDSHIP
                        ? FriendshipIconActive
                        : FriendshipInActiveIcon
                    }
                    alt="Friendship"
                    style={{
                      filter:
                        requestedConnectionStatus ===
                          CONNECTION_STATUS.FRIENDSHIP ||
                        touchedCard === CONNECTION_STATUS.FRIENDSHIP
                          ? "drop-shadow(0 12px 30px rgba(255,20,147,0.85))"
                          : undefined,
                    }}
                    className={`w-20 h-20 object-contain transition-all duration-300 ease-in-out
          ${
            requestedConnectionStatus === CONNECTION_STATUS.FRIENDSHIP ||
            touchedCard === CONNECTION_STATUS.FRIENDSHIP
              ? "scale-110 rotate-3 animate-pulse"
              : ""
          } group-hover:scale-105 group-hover:-translate-y-1 group-hover:rotate-3`}
                  />
                  <div
                    className={`mt-2 text-xs md:text-sm  group-hover:text-[13.2px] md:group-hover:text-text-[15px]   text-[#786469] transition-all duration-300 ease-in-out ${
                      requestedConnectionStatus ===
                        CONNECTION_STATUS.FRIENDSHIP ||
                      touchedCard === CONNECTION_STATUS.FRIENDSHIP
                        ? "font-bold text-pink-600"
                        : ""
                    } group-hover:font-bold group-hover:text-pink-500`}
                  >
                    Friendship / Professional
                  </div>
                </div>
              )}

              {/* Open to both */}
              {connectionVisibility.openToAnyButtonVisibility ===
                ButtonVisibility.Visible && (
                <div
                  className="flex flex-col items-center justify-center w-1/3 text-center cursor-pointer group"
                  onClick={() =>
                    sendConnectionRequest(
                      requestedConnectionStatus ===
                        CONNECTION_STATUS.OPEN_TO_ANYTHING
                        ? CONNECTION_STATUS.UNMATCH
                        : CONNECTION_STATUS.OPEN_TO_ANYTHING
                    )
                  }
                  onTouchStart={() =>
                    triggerHover(CONNECTION_STATUS.OPEN_TO_ANYTHING)
                  }
                  onMouseEnter={() =>
                    triggerHover(CONNECTION_STATUS.OPEN_TO_ANYTHING)
                  }
                >
                  <img
                    src={
                      requestedConnectionStatus ===
                      CONNECTION_STATUS.OPEN_TO_ANYTHING
                        ? OpenToAnythingIconActive
                        : OpenToAnythingIconInActive
                    }
                    alt="Open to both"
                    style={{
                      filter:
                        requestedConnectionStatus ===
                          CONNECTION_STATUS.OPEN_TO_ANYTHING ||
                        touchedCard === CONNECTION_STATUS.OPEN_TO_ANYTHING
                          ? "drop-shadow(0 12px 30px rgba(255,20,147,0.85))"
                          : undefined,
                    }}
                    className={`w-20 h-20 object-contain transition-all duration-300 ease-in-out
          ${
            requestedConnectionStatus === CONNECTION_STATUS.OPEN_TO_ANYTHING ||
            touchedCard === CONNECTION_STATUS.OPEN_TO_ANYTHING
              ? "scale-110 rotate-3 animate-pulse"
              : ""
          } group-hover:scale-105 group-hover:-translate-y-1 group-hover:rotate-3`}
                  />
                  <div
                    className={`mt-2 text-xs md:text-sm  group-hover:text-[13.2px] md:group-hover:text-text-[15px]   text-[#786469] transition-all duration-300 ease-in-out ${
                      requestedConnectionStatus ===
                        CONNECTION_STATUS.OPEN_TO_ANYTHING ||
                      touchedCard === CONNECTION_STATUS.OPEN_TO_ANYTHING
                        ? "font-bold text-pink-600"
                        : ""
                    } group-hover:font-bold group-hover:text-pink-500`}
                  >
                    Open to Both
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ConnectionButton;
